import api from "./api";

export const login = async (value) => {
  const params = {
    email: value.email,
    password: value.password,
  };

  const res = await api.post("/login", params, {
    skipAuth: true,
  });
  console.log(res);

  return res.data;
};

export const phoneVerify = async (phone) => {
  return api.post(
    "/check-mobile-exist",
    {
      country_code: phone.countryCallingCode,
      phone_number: phone.nationalNumber,
    },
    { skipAuth: true },
  );
};

export const emailVerify = async (email) => {
  return api.post("/verify-email", { email }, { skipAuth: true });
};

export const emailotpverify = async (otp, otpToken) => {
  console.log(otp, otpToken);
  return api.post(
    "/email-otp-verification",
    { otp: Number(otp) },
    {
      skipAuth: true,
      headers: {
        Authentication: otpToken,
      },
    },
  );
};
export const forget = async (email) => {
  return api.post("/forgot-otp", { email: email }, { skipAuth: true });
};
export const forgetotpverify = async (otp, otpToken) => {
  return api.post(
    "/forgot-otp-verification",
    { otp: Number(otp) },
    {
      skipAuth: true,
      headers: {
        Authentication: otpToken,
      },
    },
  );
};

export const resetpassword = async (values, token) => {
  return api.post(
    "/new-password",
    { new_password: values.password },
    {
      headers: {
        Authentication: token,
      },
    },
  );
};

export const register = async (value, token) => {
  return api.post(
    "/register",
    {
      full_name: value.name,
      email: value.email,
      country_code: value.code,
      phone_number: value.number,
      password: value.password,
      device_token: "sdafs",
      device_type: "Website",
    },
    {
      skipAuth: true,
      headers: {
        Authentication: token,
      },
    },
  );
};
